export default __webpack_public_path__ + "static/media/smart_phone_img.714c44d0.jpg";